// import { reqElevatorProjectSelectList } from '@/api/pm/pm'
import { reqElevatorProjectSelectList } from '@/api/elevatorProject/elevatorProjectApi'
import store from '@/store'
import {
    getUSERINFO
} from '@/store/cookies'

const pm = {
    state: {
        distributeObj: undefined, // 配货单对象
        projectList: [],
    },
    getters: {
        getDistributeObj: (state) => state.distributeObj,
        getProjectList: (state) => state.projectList,
    },
    mutations: {
        setDistributeObj(state, payload) {
            state.distributeObj = payload.distributeObj
        },

        setProjectList(state, payload) {
            state.projectList = payload
        }
    },
    actions: {
        searchElevatorProjectSelectList({ commit }, reqData) {
            return new Promise((resolve, reject) => {
                let projectList = store.getters["getProjectList"]
                if (projectList.length) resolve({ "data": { "info": projectList } })
                else {
                    let params = reqData ? JSON.parse(JSON.stringify(reqData)) : {}
                    const temp = JSON.parse(getUSERINFO())
                    params.permissionUserId = temp.vUserId
                    reqElevatorProjectSelectList(params).then(response => {
                        let array = response && response.data && response.data.info ? response.data.info : []
                        array = array.map((project) => {
                            return {
                                v_project_id: project.projectId,
                                v_project_name: project.projectName
                            }
                        })
                        commit("setProjectList", array);
                        resolve({ "data": { "info": array } })
                    })
                }
            })
        },
        clearProjectSelectListCache({ commit }, reqData) {
            return new Promise((resolve, reject) => {
                commit("setProjectList", [])
            })
        },
    },
}

export default pm